var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',[_c('v-col',{attrs:{"cols":"12"}},[_c('v-card',{attrs:{"flat":"","outlined":""}},[_c('v-card-text',[_c('iframe',{staticStyle:{"border":"0"},attrs:{"width":"100%","height":"2500","src":"https://datastudio.google.com/embed/reporting/249f06c4-e932-4994-9bd1-fe047eda010b/page/6c2HC","frameborder":"0","allowfullscreen":""}})])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }